import angular from 'angular';

angular.module('webTools').factory('Settings', [
	function () {

	    var _importSettings = [];

	    return {

	        setImportSettings: function (settings) {
	            _importSettings = settings;
	        },

	        getImportSettings: function () {
	            return _importSettings;
	        }
	    }
	}
]);